/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ year: NonNullable<unknown> }} Retrospective_Year_InvalidInputs */

const en_us2_retrospective_year_invalid = /** @type {(inputs: Retrospective_Year_InvalidInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`That year does not exist: ${i?.year}. Pick another.`)
};

const pt_br2_retrospective_year_invalid = /** @type {(inputs: Retrospective_Year_InvalidInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Esse ano não existe: ${i?.year}. Escolha outro.`)
};

const es_419_retrospective_year_invalid = /** @type {(inputs: Retrospective_Year_InvalidInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ese año no existe: ${i?.year}. Elige otro.`)
};

const pt_pt2_retrospective_year_invalid = /** @type {(inputs: Retrospective_Year_InvalidInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Esse ano não existe: ${i?.year}. Escolhe outro.`)
};

const fr_fr2_retrospective_year_invalid = /** @type {(inputs: Retrospective_Year_InvalidInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Cette année n'existe pas : ${i?.year}. Choisis-en une autre.`)
};

const de_de2_retrospective_year_invalid = /** @type {(inputs: Retrospective_Year_InvalidInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Dieses Jahr gibt es nicht: ${i?.year}. Wähle ein anderes.`)
};

const it_it2_retrospective_year_invalid = /** @type {(inputs: Retrospective_Year_InvalidInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Questo anno non esiste: ${i?.year}. Scegline un altro.`)
};

/**
* | output |
* | --- |
* | "That year does not exist: {year}. Pick another." |
*
* @param {Retrospective_Year_InvalidInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const retrospective_year_invalid = /** @type {((inputs: Retrospective_Year_InvalidInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Retrospective_Year_InvalidInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_retrospective_year_invalid(inputs)
	if (locale === "es-419") return es_419_retrospective_year_invalid(inputs)
	if (locale === "pt-PT") return pt_pt2_retrospective_year_invalid(inputs)
	if (locale === "fr-FR") return fr_fr2_retrospective_year_invalid(inputs)
	if (locale === "de-DE") return de_de2_retrospective_year_invalid(inputs)
	if (locale === "it-IT") return it_it2_retrospective_year_invalid(inputs)
	return en_us2_retrospective_year_invalid(inputs)
});
export { retrospective_year_invalid as "retrospective.year_invalid" }